import { RouterModule, Routes } from '@angular/router';

import { PagesComponent } from './pages.component';
import { LoginGuardGuard } from '../services/service.index';
import { NopagefoundComponent } from '../shared/nopagefound/nopagefound.component';
import { AfficontrollComponent } from './afficontroll/afficontroll.component';

const pagesRoutes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate: [LoginGuardGuard],
    children: [
      { path: 'afiliados', component: AfficontrollComponent, data: { titulo: 'ACTUALIZACIÓN DE DATOS' } },
      { path: '', component: NopagefoundComponent }
    ]
  }
];

export const PAGES_ROUTES = RouterModule.forChild( pagesRoutes );
